import React, { useRef } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import '../layout/sass/_form.scss';

import yaml from 'js-yaml';


export const FormLogs = ({ isLoading, defaultValues }) => {

    const toast = useRef(null);

    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome é obrigatório")
            .max(200, "O nome dete ter no máximo 200 caracteres"),
        embalagem: Yup
            .string()
            .required("A embalagem é obrigatório")
            .max(200, "A embalagem dete ter no máximo 200 caracteres"),
        pesoEmKg: Yup
            .number()
            .required("O peso da embalágem é obrigatório")
            .positive("O peso da embalágem deve ser maior ou igual a 1"),


    })

    const formik = useFormik({

        initialValues: defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

    })

    const formatDate = (dateString) => {
        if (!dateString) {
            return ''; // Se dateString for undefined ou null, retorna uma string vazia
        }
        const [ano, mes, dia] = dateString.split("-");
        return `${dia}/${mes}/${ano}`;
    };

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    // Função genérica para converter a string para um objeto
    const parseDTO = (str) => {
        const regex = /([a-zA-Z0-9]+)\(([^)]+)\)/;
        const matches = str.match(regex);

        if (matches) {
            const dtoName = matches[1]; // Nome do DTO (ex: PrecosDTO)
            const fields = matches[2].split(',').map((field) => field.trim());

            // Criar um objeto com as propriedades extraídas
            const dtoObject = { _dtoName: dtoName };
            fields.forEach((field) => {
                const [key, value] = field.split('=').map((part) => part.trim());
                if (value) {
                    dtoObject[key] = value;
                }
            });

            return dtoObject;
        }

        return null;
    };

    let parsedContent = null;
    if (formik.values.conteudo) {
        parsedContent = parseDTO(defaultValues.conteudo);
    }

    const yamlContent = parsedContent ? yaml.dump(parsedContent) : '';

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Logs</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="usuario"
                                className={classNames({ 'p-error': isFormFieldValid('usuario') })}
                            >
                                Usuário
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="usuario"
                                        name="usuario"
                                        className={classNames({ 'p-invalid': isFormFieldValid('usuario') })}
                                        value={formik.values.usuario}
                                        readOnly
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.usuario && formik.touched.usuario &&
                                <ErrorValidationMessage message={formik.errors.usuario} />
                            }
                        </div>
                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="updated"
                                className={classNames({ 'p-error': isFormFieldValid('updated') })}
                            >
                                Updated
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="updated"
                                        name="updated"
                                        className={classNames({ 'p-invalid': isFormFieldValid('updated') })}
                                        value={formatDate(formik.values.updated)}
                                        readOnly
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.updated && formik.touched.updated &&
                                <ErrorValidationMessage message={formik.errors.updated} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="cadastroId"
                                className={classNames({ 'p-error': isFormFieldValid('cadastroId') })}
                            >
                                Cód Cadastro
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="cadastroId"
                                        name="cadastroId"
                                        type="number"
                                        className={classNames({ 'p-invalid': isFormFieldValid('cadastroId') })}
                                        value={formik.values.cadastroId}
                                        readOnly
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.cadastroId && formik.touched.cadastroId &&
                                <ErrorValidationMessage message={formik.errors.cadastroId} />
                            }
                        </div>


                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="cadastro"
                                className={classNames({ 'p-error': isFormFieldValid('cadastro') })}
                            >
                                Cadastro
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="cadastro"
                                        name="cadastro"
                                        className={classNames({ 'p-invalid': isFormFieldValid('cadastro') })}
                                        value={formik.values.cadastro}
                                        readOnly
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.cadastro && formik.touched.cadastro &&
                                <ErrorValidationMessage message={formik.errors.cadastro} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="acao"
                                className={classNames({ 'p-error': isFormFieldValid('acao') })}
                            >
                                Ação
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="acao"
                                        name="acao"
                                        className={classNames({ 'p-invalid': isFormFieldValid('acao') })}
                                        value={formik.values.acao}
                                        readOnly
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.acao && formik.touched.acao &&
                                <ErrorValidationMessage message={formik.errors.acao} />
                            }
                        </div>


                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="conteudo"
                                className={classNames({ 'p-error': isFormFieldValid('conteudo') })}
                            >
                                Conteúdo
                            </label>
                            {
                                !isLoading ?
                                    <pre>

                                        {yamlContent}

                                    </pre>
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.conteudo && formik.touched.conteudo &&
                                <ErrorValidationMessage message={formik.errors.conteudo} />
                            }
                        </div>

                    </div>
                </form>
            </div>
        </div>

    );
}
